import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import './NavbarPanelViewer.sass';

import { buildTestid } from '../../../lib/utils';

export interface ViewerProps extends
  WithDataTestid,
  WithClassNameProp {
  name: string;
  role?: string;
}

const displayName = 'NavbarPanelViewer';
const testid = buildTestid(displayName);

function NavbarPanelViewer({
  name,
  role = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: ViewerProps): React.JSX.Element {
  return (
    <div
      {...testid(dataTestId)}
      className={cn('NavbarPanelViewer', className)}
    >
      <span
        {...testid('Name', dataTestId)}
        className={cn('NavbarPanelViewer__Name')}
      >
        {name}
      </span>

      {!!role && (
        <span
          {...testid('Role', dataTestId)}
          className={cn('NavbarPanelViewer__Role')}
        >
          {role}
        </span>
      )}
    </div>
  );
}

NavbarPanelViewer.displayName = displayName;

export { NavbarPanelViewer };
